import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "./app/routes";
import { AppStateProvider } from "./state/AppStateProvider";

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppStateProvider>
          <AppRoutes />
          <ToastContainer
            position="top-left"
            autoClose={4000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            draggable={false}
            theme="light"
          />
        </AppStateProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
